import { createContext, useContext, useMemo } from "react";
import { useNotifications } from "@/hooks/useNotifications";
import type { NotificationItem } from "@/lib/api";

type NotificationContextValue = {
	items: NotificationItem[];
	unreadCount: number;
	loading: boolean;
	error: string | null;
	fetchNotifications: () => Promise<void>;
	fetchUnreadCount: () => Promise<void>;
	markRead: (id: string) => Promise<void>;
	markAllRead: () => Promise<void>;
	pushNotification: (notif: NotificationItem) => void;
};

const NotificationContext = createContext<NotificationContextValue | null>(null);

export function NotificationProvider({ children }: { children: React.ReactNode }) {
	const notifications = useNotifications();

	const value = useMemo(
		() => notifications,
		[notifications],
	);

	return (
		<NotificationContext.Provider value={value}>
			{children}
		</NotificationContext.Provider>
	);
}

export function useNotificationContext(): NotificationContextValue {
	const ctx = useContext(NotificationContext);
	if (!ctx) {
		throw new Error("useNotificationContext must be used within NotificationProvider");
	}
	return ctx;
}
